import { DisplayType, MenuState } from 'common/ducks/menu'
import { StateKey } from 'common/utils/flipState'
import { SubVertical } from 'common/constants'
import { DisplayMenu, MenuLayer } from 'common/types/entities/mongo/menu'
import { fetchCompositeLayers } from 'common/services/finder/compositeMenu'
import { fetchBy } from 'common/services/finder/menu'

const initialState: MenuState = {
  subVertical: null,
  channelId: null,
  storeCategoryId: null,
  displayType: DisplayType.COMPOSITE_CATEGORY_HOME,
  first: {},
  second: {},
  third: {},
}

// action types
const INIT = 'compositeMenu/INIT'
const SET_FIRST = 'compositeMenu/SET_FIRST'
const SET_SECOND = 'compositeMenu/SET_SECOND'
const SET_THIRD = 'compositeMenu/SET_THIRD'

export const initCompositeMenu = (
  curState: StateKey,
  subVertical: SubVertical,
  displayType: DisplayType,
  layer1MenuId?: string,
  layer2MenuId?: string,
) => async dispatch => {
  const layers: MenuLayer[] = await fetchCompositeLayers(subVertical, displayType, layer1MenuId, layer2MenuId)

  dispatch({
    curState,
    type: INIT,
    result: {
      subVertical,
      first: (layers && layers[0]) || {},
      second: (layers && layers[1]) || {},
      third: (layers && layers[2]) || {},
      displayType: DisplayType.CATEGORY_HOME,
    },
  })
}

export const setFirstMenu = (curState: StateKey, menuId: string) => async dispatch => {
  dispatch({ curState, menuId, type: SET_FIRST })
}

export const setSecondMenu = (curState: StateKey, menuId: string) => async (dispatch, getState) => {
  const state: MenuState = getState().compositeMenu[curState]
  const displayMenu = state.second.displayMenus.find(menu => menu.id === menuId)
  if (displayMenu && displayMenu.name === '전체') {
    dispatch({ curState, menuId, third: {}, type: SET_SECOND })
    return
  }
  const displayMenus: DisplayMenu[] =
    menuId !== state.second.selectedId
      ? await fetchBy(state.subVertical, menuId, DisplayType.CATEGORY_HOME)
      : state.third.displayMenus

  dispatch({ curState, menuId, third: generateMenuLayer(displayMenus, menuId), type: SET_SECOND })
}
const generateMenuLayer = (displayMenus: DisplayMenu[], selectedId: string) => ({ displayMenus, selectedId })

export const setThirdMenu = (curState: StateKey, menuId: string) => async dispatch => {
  dispatch({ curState, menuId, type: SET_THIRD })
}

export default (state = initialState, action) => {
  switch (action.type) {
    case INIT:
      return { ...initialState, ...action.result }
    case SET_FIRST:
      return { ...state, first: { ...state.first, selectedId: action.menuId } }
    case SET_SECOND:
      return { ...state, second: { ...state.second, selectedId: action.menuId }, third: action.third }
    case SET_THIRD:
      return { ...state, third: { ...state.third, selectedId: action.menuId } }
    default:
      return state
  }
}
